export const NoticeConst = {
    Normal:0,      // 通常
    Important:1,   // 重要
    System:2,      // システム・メンテナンス
    Business:3     // 取引・入札
} as const;

export type NoticeType = typeof NoticeConst[keyof typeof NoticeConst];

export const NoticeLabelConst: Record<NoticeType, string> = {
  [NoticeConst.Normal]: "お知らせ",
  [NoticeConst.Important]: " 重　要 ",
  [NoticeConst.System]: "システム",
  [NoticeConst.Business]: " 取　引 ",
} as const;